import type { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.Container';

export const Container: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => (
  <div className={twMerge('pt-3 pb-6 pl-3 pr-2', className)} data-product-info {...props}>
    {children}
  </div>
);

Container.displayName = DISPLAY_NAME;
